import { render } from "./NodeProvince.vue?vue&type=template&id=3dbbe411"
import script from "./NodeProvince.vue?vue&type=script&lang=js"
export * from "./NodeProvince.vue?vue&type=script&lang=js"

import exportComponent from "/opt/build/repo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__